<template>
    <div class="order-list-box" @click="goOrderDetail">
        <div class="order-info">
            <div class="avatar-wrap">
                <div class="img-wrap">
                    <img v-if="candidate.gender == 2" :src="candidate.avatar.remoteUrl | avatar('women')" v-img-error-user="2" alt="" />
                    <img v-else :src="candidate.avatar.remoteUrl | avatar('men')" v-img-error-user="1" alt="" />
                </div>
                <b v-if="candidate.hasNewFeedback && name != 'aiMatch'" class="red-circle"></b>
                <b v-if="candidate.unReadCount && name == 'aiMatch'" class="red-circle"></b>
            </div>
            <div class="info-wrap">
                <div class="info-box flex-box">
                    <span class="name w80">{{candidate.candidateName}}<b class="order-id">#{{candidate.candidateId}}</b></span>
                    <span v-if="candidate.candidateTracks && candidate.candidateTracks.length && candidate.candidateTracks[0].progressType && candidate.candidateTracks[0].progressType == 57" class="tips-status status-nopass">自动打回</span>
                    <span v-else class="tips-status" :class="[2,3,8,9,12,13,14,16,20,21,24].includes(candidate.allStatus) ? 'status-nopass' : 'status-pass'">{{candidate.allStatus | allCandidateStatus}}</span>
                    <span v-if="candidate.homoCount && candidate.homoCount > 0" class="btn-color-wrap btn-color-blue">
                        <a class="btn-color" href="javascript:;">AI复推<span class="num">({{candidate.homoCount}})</span></a>
                    </span>
                </div>
                <div class="info-box flex-box">
                    <span class="title van-ellipsis">公司：{{candidate.enterpriseBaseEntity&&candidate.enterpriseBaseEntity.enterpriseName ? candidate.enterpriseBaseEntity.enterpriseName : ""}}</span>
                </div>
                <div class="info-box flex-box">
                    <span class="title van-ellipsis w80">职位：{{candidate.positionBaseEntity&&candidate.positionBaseEntity.positionTitle ? candidate.positionBaseEntity.positionTitle : ""}}</span>
                    <span class="tips-time" v-if="candidate.recommendTime">{{candidate.recommendTime | date}}推荐</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import defaultAvatarBoy from "@/assets/default/boy40.png";
import defaultAvatarGirl from "@/assets/default/girl40.png";
export default {
  name: "recruit-module",
  props: {
    candidate: {},
    from: {}
  },
  data(){
    return{
      name: this.$route.name,
      defaultAvatarBoy: defaultAvatarBoy,
      defaultAvatarGirl: defaultAvatarGirl
    };
  },
  components: {},
  methods: {
    goOrderDetail(){
      this.candidate.hasNewFeedback = false;
      if(this.from == 'ai'){
        this.$router.push({ path: `/aiMatch/recommendDetail/${this.candidate.candidateId}?talentId=${this.candidate.talentId}`});  
      }else{
        this.$router.push({ path:`/order/detail/${this.candidate.candidateId}`});  
      }
    }
  },
  created() {}
};
</script>

<style scoped lang="scss">
    .order-list-box {
        background-color: #fff;
        margin-bottom: 10px;
        padding: 15px;
        .order-info{
            overflow: hidden;
            .avatar-wrap{
                float: left;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                position: relative;
                .red-circle{
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    position: absolute;
                    background: #FA3E25;
                    top: 4px;
                    right: 0;
                }
            }
            .info-wrap{
                margin-left: 50px;
                overflow: hidden;
                .info-box{
                    margin-bottom: 5px;
                }
                .flex-box{
                    align-items: baseline;
                }
                .name{
                    font-size: 16px;
                    color: #333;
                    margin-right: 10px;
                }
                .order-id{
                    margin-left: 10px;
                    font-size: 12px;
                    color: #666;
                    font-weight: normal;
                }
                .tips-status{
                    border-radius: 2px;
                    padding: 0 4px;
                    height: 17px;
                    line-height: 17px;
                    font-size: 10px;
                    justify-self: flex-end;
                    white-space: nowrap;
                    &:not(:last-child){
                        margin-right: 5px;
                    }
                }
                .status-nopass{
                    color: #FF6E00;
                    border: .5px solid #FF6E00;
                }
                .status-pass{
                    color: #22BAA5;
                    border: .5px solid #22BAA5;
                }
                .btn-color-wrap{
                    overflow: initial;
                    height: 17px;
                    .btn-color{
                        line-height: 17px;
                    }
                }
                .title{
                    color: #666;
                    font-size: 14px;
                }
                .tips-time{
                    color: #999;
                    font-size: 12px;
                    text-align: right;
                    align-self: flex-start;
                    justify-self: flex-end;
                    white-space: nowrap;
                }
                .w80{
                    flex: 1;
                    /*width: 80%;*/
                    margin-right: 10px;
                }
            }
        }
    }
</style>
